import React, { useEffect, useMemo, useState } from "react";
import "./cssheader.css";
// import Mon_CV from "../../assets/templates/Aubin_SIAHA_CV_Developper_fr.pdf";
// import My_CV from "../../assets/templates/Aubin_SIAHA_CV_Developer_en.pdf";
import MOI from "../../assets/templates/ma_pp.jpg";

import { AiFillLinkedin } from "react-icons/ai";
import { ImYoutube, ImTwitter, ImGithub } from "react-icons/im";
import { FaFacebookF, FaArrowAltCircleDown } from "react-icons/fa";
import LocaleSwitcher from "../../i18n/LocaleSwitcher";

import { useTranslation } from "react-i18next";
import axios from "axios";
import { baseURL } from "../../App";
import ThemeToggle from "../Toggle/toggle";
import SkeletonLoader from "../Skeleton/SkeletonLoader";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [headerData, setHeaderData] = useState({
    works: { en: [], fr: [] },
    cvLinks: { en: "", fr: "" },
    image: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentText, setCurrentText] = useState("");
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [timeoutDuration, setTimeoutDuration] = useState(150);
  // const works = useMemo(() => {
  //   return [t("work1"), t("work2"), t("work3"), t("work4")];
  // }, [t]);
  const API_URL = `${baseURL}/api/header`;

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(API_URL);
        const data = response.data[response.data.length - 1] || {};
        setHeaderData({
          works: data.works || { en: [], fr: [] },
          cvLinks: data.cvLinks || { en: "", fr: "" },
          image: data.image || "",
        });
      } catch (err) {
        setError("Error fetching profile data");
        console.error("Error fetching profile data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProfileData();
  }, [API_URL]);

  // Typing effect for "works"
  const works = useMemo(() => {
    // Get works based on current language
    const currentWorks =
      i18n.language === "en" ? headerData.works?.en : headerData.works?.fr;
    return currentWorks || []; // Return empty array if no works are found
  }, [headerData.works, i18n.language]);

  useEffect(() => {
    const handleTyping = () => {
      if (!works || works.length === 0) {
        return;
      }
      const currentWork = works[index];

      if (isDeleting) {
        // Remove a character
        setCurrentText(currentWork.substring(0, currentText.length - 1));

        // Decrease the timeout duration for a smoother erase
        setTimeoutDuration(50);

        // Check if we have finished deleting
        if (currentText === "") {
          setIsDeleting(false);
          setIndex((prevIndex) => (prevIndex + 1) % works.length); // Move to the next work
        }
      } else {
        // Add a character
        setCurrentText(currentWork.substring(0, currentText.length + 1));

        // Increase the timeout duration for a smoother type
        setTimeoutDuration(150);

        // Check if we have finished typing the current work
        if (currentText === currentWork) {
          setIsDeleting(true);
        }
      }
    };

    const timer = setTimeout(handleTyping, timeoutDuration);

    return () => clearTimeout(timer);
  }, [currentText, isDeleting, index, works, timeoutDuration]);

  if (loading) {
    return (
      <header id="accueil">
        <div className="navbar">
          <LocaleSwitcher />
          <ThemeToggle />
        </div>
        <SkeletonLoader type="card" />
      </header>
    );
  }
  if (error) return <p>{error}</p>;

  return (
    <header id="accueil">
      <div className="navbar">
        <LocaleSwitcher />
        <ThemeToggle />
      </div>
      <div className="container header_container">
        <h5>{t("greeting")}</h5>
        <h1>{t("myName")}</h1>
        <h5 className="ICan_container">
          <ul className="ICan">
            <li>
              <span>{currentText}</span>
              <span className="cursor"></span>
            </li>
          </ul>
        </h5>
        <div className="contacter">
          <a
            href={
              i18n.language === "en"
                ? headerData.cvLinks?.en
                : headerData.cvLinks?.fr
            }
            download
            className="btn"
            target="blank"
          >
            {t("downloadCV")}
          </a>
          <a href="#contact" className="btn btnPrimary">
            {t("writeToMe")}
          </a>
        </div>
        <div className="MOI">
          <img src={headerData.image || MOI} alt="moi" />
        </div>
        <a href="#contact" className="scroll">
          <FaArrowAltCircleDown />
        </a>
        <div className="reseaux_sociaux">
          <a href="https://www.linkedin.com/in/aubinsiaha" target="blank">
            <AiFillLinkedin />
          </a>
          <a href="https://www.youtube.com/@maau_tech" target="blank">
            <ImYoutube />
          </a>
          <a href="https://github.com/Aubin9" target="blank">
            <ImGithub />
          </a>
          <a href="http://www.facebook.com/maautec" target="blank">
            <FaFacebookF />
          </a>
          <a href="https://x.com/aubinsiaha" target="blank">
            <ImTwitter />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
